/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * 
 */

let baseUrl = ''; 
let routerMode = 'hash';
// let routerMode = 'history';
let imgBaseUrl = '';


if (process.env.NODE_ENV == 'development') {
    baseUrl = '//club.api.mgtv.com';
    imgBaseUrl = '../../'

}else if(process.env.NODE_ENV == 'production'&& document.domain=="club.mgtv.com"){
    baseUrl = '//club.api.mgtv.com';
}
else{
    baseUrl = '//club.api.mgtv.com';
}

export {
	baseUrl,
	routerMode,
	imgBaseUrl,
}


// WEBPACK FOOTER //
// ./src/api/env.js